import * as m from "react";
import { i as d, E as p, x as s, r as u, c as _ } from "../createReactComponent-58f9bea8.mjs";
import { n as b } from "../property-9daa16cd.mjs";
import { r as x } from "../icon-c572aa57.mjs";
import "../class-map-2994e95e.mjs";
const f = d`
  :host {
    display: inline-flex;
  }

  .breadcrumb-item {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
  }

  .breadcrumb-item__label {
    display: inline-block;
    text-decoration: none;
    background: none;
    border: none;
    border-radius: none;
    padding: var(--exo-spacing-none);
    margin: var(--exo-spacing-none);
  }

  :host(:not(:last-of-type)) .breadcrumb-item__label {
    font: var(--exo-text-label-micro);
    color: var(--exo-color-font-link);
    text-decoration: underline;
  }

  :host(:last-of-type) .breadcrumb-item__label {
    font: var(--exo-text-label-micro);
    color: var(--exo-color-font-secondary);
  }

  :host(:not(:last-of-type)) .breadcrumb-item__label:hover {
    color: var(--exo-color-font-link-hover);
  }

  :host(:not(:last-of-type)) .breadcrumb-item__label:active {
    color: var(--exo-color-font-link);
  }

  .breadcrumb-item__label:focus {
    outline: none;
  }

  .breadcrumb-item__label:focus-visible {
    outline: var(--exo-spacing-4x-small) solid var(--exo-color-border-selected);
  }

  :host(:last-of-type) .breadcrumb-item__separator {
    display: none;
  }

  .breadcrumb-item__separator {
    display: inline-flex;
    align-items: center;
    user-select: none;
    font-size: var(--exo-font-size-small);
    color: var(--exo-color-border);
    margin: var(--exo-spacing-none) var(--exo-spacing-2x-small);
  }
`;
var g = Object.defineProperty, v = Object.getOwnPropertyDescriptor, c = (e, a, l, o) => {
  for (var n, r = o > 1 ? void 0 : o ? v(a, l) : a, i = e.length - 1; i >= 0; i--)
    (n = e[i]) && (r = (o ? n(a, l, r) : n(r)) || r);
  return o && r && g(a, l, r), r;
}, k = ((e) => (e.BLANK = "_blank", e.PARENT = "_parent", e.SELF = "_self", e.TOP = "_top", e))(k || {}), h = ((e) => (e.NO_REFERRER = "noreferrer", e.NO_OPENER = "noopener", e))(h || {});
class t extends p {
  constructor() {
    super(...arguments), this.linkTarget = "_self", this.linkRel = "";
  }
  getBreadCrumbLink() {
    return this.link ? s`
        <a
          part="label"
          class="breadcrumb-item__label breadcrumb-item__label--link"
          href=${this.link}
          target=${this.linkTarget}
          rel=${this.linkRel}
        >
          <slot></slot>
        </a>
      ` : s`
      <button
        part="label"
        type="button"
        class="breadcrumb-item__label breadcrumb-item__label--button"
      >
        <slot></slot>
      </button>
    `;
  }
  render() {
    return s`
      <div class="breadcrumb-item">
        ${this.getBreadCrumbLink()}
        <span class="breadcrumb-item__separator" aria-hidden="true"> / </span>
      </div>
    `;
  }
}
t.styles = f, c([b()], t.prototype, "link", 2), c([b()], t.prototype, "linkTarget", 2), c([b()], t.prototype, "linkRel", 2);
const y = (e = "") => {
  u("ex-breadcrumb-item", t, e), x();
}, O = _({ tagName: "ex-breadcrumb-item", elementClass: t, react: m, events: {}, displayName: "ExBreadcrumbItem", registerWebComponent: y });
export {
  h as BreadcrumbLinkRel,
  k as BreadcrumbLinkTarget,
  O as ExBreadcrumbItem,
  y as register
};
